import { SAVE_TASK_SUCCESS,SAVE_TASK_FAILURE,STOP_LOADING,START_LOADING,UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAILURE ,GET_TASK_SUCCESS,GET_TASK_FAILURE,DELETE_TASK_FAILURE,DELETE_TASK_SUCCESS,
   GET_TYPE_TASK_LIST_SUCCESS, GET_TYPE_TASK_LIST_FAILURE,GET_CLIENT_SUCCESS,GET_CLIENT_FAILURE,
   GET_DUE_TASK_SUCCESS, GET_DUE_TASK_FAILURE} from "./actionTypes";
import { saveTask,updateTask,getAllTask,deleteTaskById, searchTask, getTaskByPolicy, searhUserTaskServices, searchTaskCalendar, searchTaskLinear, searchCommonTask, getClientCustomer,
  getTypeOfTaskOpenServices, getDueTask,
  getCustomerByPolicyId
  } from "../../services/taskServices";
import { openSessionTimeoutModal } from './sessionTimeOutActions';

export const saveTaskAction = (formData, successCallback, errorCallback) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_TASK' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveTask(formData, token);
    dispatch({ type: STOP_LOADING, service: 'SAVE_TASK' });
    dispatch({ type: SAVE_TASK_SUCCESS, payload: response });

    if (response && successCallback) {
      successCallback(response);
    }
  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'SAVE_TASK' });
      dispatch({
        type: SAVE_TASK_FAILURE,
        payload: error || 'Save task service failed. Please try again.'
      });

      if (errorCallback) {
        errorCallback(error || 'Save task service failed. Please try again.');
      }
    }
  }
};

export const searchTaskAction = (formData, policyId, page = 0, size = 5, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");

    const searchData = {
      ...formData,
    };

    if (formData.selectedOption === "All" && formData.clientCustomerId) {
      searchData.clientCustomerId = formData.clientCustomerId;
    }

    const response = await searchTask(searchData, token, policyId, page, size);

    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    if (response && typeof callbackfn === 'function') {
      callbackfn(response);
    }
    dispatch({ type: 'SEARCH_TASK_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({
      type: 'SEARCH_TASK_FAILURE',
      payload: error || 'Search task service failed. Please try again.'
    });
    if (typeof callbackfn === 'function') {
      callbackfn(null, error);
    }
  }
};

  export const searchTaskCalendarAction = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });

        const token = getState().auth.token || sessionStorage.getItem("token");
        if (!token) {
            throw new Error("Authentication token is missing.");
        }

        const response = await searchTaskCalendar(formData, token);

        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'SEARCH_TASK_CALENDAR_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        if (error.response?.status === 403) {
            dispatch(openSessionTimeoutModal());
        } else {
            dispatch({
                type: 'SEARCH_TASK_CALENDAR_FAILURE',
                payload: error.message || 'Search Task Calendar service failed. Please try again.',
            });
        }
    }
};


export const searchTaskLinearAction = (formData, page, size) => async (dispatch, getState) => {
  try {
      dispatch({ type: START_LOADING, service: 'SEARCH_TASK_LINEAR' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      if (!token) {
           throw new Error("Authentication token is missing.");
      }const response = await searchTaskLinear(formData, token, page, size);

      dispatch({ type: STOP_LOADING, service: 'SEARCH_TASK_LINEAR' });
      dispatch({ type: 'SEARCH_TASK_LINEAR_SUCCESS', payload: response });
  } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'SEARCH_TASK_LINEAR' });
      if (error.response?.status === 403) {
          dispatch(openSessionTimeoutModal());
      } else {
          dispatch({
              type: 'SEARCH_TASK_LINEAR_FAILURE',
              payload: error.message || 'Search Task Calendar service failed. Please try again.',
          });
      }
  }
};

export const searchCommonTaskAction = (formData, page, size) => async (dispatch, getState) => {

  try {

      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      if (!token) {
          throw new Error("Authentication token is missing.");
      }

      const response = await searchCommonTask(formData, token, page, size);

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SEARCH_COMMON_TASK_SUCCESS', payload: response });

  } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      if (error.response?.status === 403) {
          dispatch(openSessionTimeoutModal());
      } else {
          dispatch({
              type: 'SEARCH_COMMON_TASK_FAILURE',
              payload: error.message || 'Search Common Task Calendar service failed. Please try again.',
          });
      }
  }
};

export const updateTaskAction = (formData, successCallback, errorCallback) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");;
      const response = await updateTask(formData, token);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      if (response && successCallback) {
        successCallback(response);
      }
      dispatch({ type: UPDATE_TASK_SUCCESS, payload: response });
    } catch (error) {
      if (error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({
          type: UPDATE_TASK_FAILURE,
          payload: error || 'Update task service failed. Please try again.'
        });

        if (errorCallback) {
          errorCallback(error || 'Update task service failed. Please try again.');
        }
    }
  }
  };

  export const getClientCustomerId = (id) => async (dispatch, getState) => {
    try {

        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getClientCustomer(id, token); // Pass the id here
        dispatch({ type: GET_CLIENT_SUCCESS, payload: response });
    } catch (error) {
        if (error?.includes("403")) {
        } else {
            dispatch({ type: GET_CLIENT_FAILURE, payload: error || 'All task service failed. Please try again.' });
        }
    }
};

  export const getAllTaskAction = (page = 0, size = 5, fromDate = null, toDate = null) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");

      const response = await getAllTask(token, page, size, fromDate, toDate);

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: GET_TASK_SUCCESS, payload: response });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
        dispatch({ type: GET_TASK_FAILURE, payload: error || 'All task service failed. Please try again.' });
      }
    }
  };


  export const getAllTaskLinearAction= (page = 0, size = 5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getAllTask(token,page,size);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: "GET_TASK_LINEAR_SUCCESS", payload: response });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
        dispatch({ type: "GET_TASK_LINEAR_FAILURE", payload: error || 'All task service failed. Please try again.' });
      }
    }
  };

  export const deleteTaskActionById = (Id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'ALL_TASK' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response= await deleteTaskById(Id,token);
      dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });

      dispatch({ type: DELETE_TASK_SUCCESS, payload: Id });
      return response;
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
      dispatch({ type: DELETE_TASK_FAILURE, payload: error.message || 'All task service failed. Please try again.' });
    }
  };

  export const getDueTaskAction = (
    page = 0,
    size = 5,
    fromDate = null,
    toDate = null,
    status = "Open"
  ) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");

      const response = await getDueTask(token, page, size, fromDate, toDate, status);

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: GET_DUE_TASK_SUCCESS, payload: response });
    } catch (error) {
      if (error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
        dispatch({
          type: GET_DUE_TASK_FAILURE,
          payload: error || 'All task service failed. Please try again.',
        });
      }
    }
  };

  export const getTaskByPolicyAction= (policyId,page = 0, size = 5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'ALL_TASK' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getTaskByPolicy(token,policyId,page,size);
      dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
      dispatch({ type: GET_TASK_SUCCESS, payload: response });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
        dispatch({ type: GET_TASK_FAILURE, payload: error || 'All task service failed. Please try again.' });
      }
    }
  };


  export const searchUserOnTaskAction= (searchterm, page = 0, size = 5) => async (dispatch, getState) => {
    try {
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await searhUserTaskServices(token, searchterm, page, size);
      dispatch({ type: "SEARCH_USER_TASK_SUCCESS", payload: response });
    } catch (error) {
        dispatch({ type: "SEARCH_USER_TASK_FAILURE", payload: error || 'All search user task action failed. Please try again.' });
    }
  };


  export const getTypeOfTaskOpenListAction = () => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");
      const response = await getTypeOfTaskOpenServices(token);
      dispatch({ type: GET_TYPE_TASK_LIST_SUCCESS, payload: response });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: GET_TYPE_TASK_LIST_FAILURE, payload: error || 'Type task list service failed. Please try again.' });
      }
    }
  };


  export const getCustomerFromPolicyAction = (policyId) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");

      const response = await getCustomerByPolicyId(policyId,token);

      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: "GET_CUSTOMER_POLICY_SUCCESS", payload: response });
      return { payload: response };
    } catch (error) {
      if(error?.includes("403")) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({ type: STOP_LOADING, service: 'ALL_TASK' });
        dispatch({ type: GET_TASK_FAILURE, payload: error || 'All task service failed. Please try again.' });
      }
    }
  };
